export interface DoubleCheckOrderIconProps {
  className?: string;
}
export const DoubleCheckOrderIcon = ({
  className,
}: DoubleCheckOrderIconProps) => {
  return (
    <div data-testid="double-check-order-icon" className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M10.6665 6H13.6665"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.667 10.667H16.0003"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6665 16H13.3332"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.667 21.333H16.0003"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6665 26H14.6665"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24 8.66667V3C24 1.89543 24.8954 1 26 1H28C29.1046 1 30 1.89543 30 3V8.66667C30 9.40305 29.403 10 28.6667 10H25.3333"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27 1H10C7.79086 1 6 2.79086 6 5V25C6 29 4 30.168 2 31H18C21.3137 31 24 28.3137 24 25V22"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21 22.667C24.866 22.667 28 19.533 28 15.667C28 11.801 24.866 8.66699 21 8.66699C17.134 8.66699 14 11.801 14 15.667C14 19.533 17.134 22.667 21 22.667Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.9999 25.6669L25.9492 20.6162"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
